<template>
    <v-card>
      <department-selector v-model="tab" :departments="departmentUserObjectives" label="部门" class="mb-2" />
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(dep) in departmentUserObjectives" :key="dep.departmentid">
          <v-row flat color="white">
            <v-col cols="6" md="4" id="pagetitle">
            <p class="ml-2">{{dep.departmentname}} - 考核目标 {{dep.changed?'*':''}}</p>
            </v-col>
            <v-col cols="4" class="d-none d-md-block">
              <v-file-input :label="'导入'+dep.departmentname+'考核目标'" v-model="importedfile" 
                show-size @change='fileimport'></v-file-input>
            </v-col>
            <v-col cols="4">
              <v-btn class="ml-2" color="primary"
                :disabled="dep.userObjectives.length ==0 || !dep.changed" 
                @click.stop.prevent="save(dep)">
                  <v-icon left>mdi-content-save</v-icon>
                  <span class="d-none d-md-block">保存{{dep.departmentname}}绩效考核目标</span>
              </v-btn>
              </v-col>
          </v-row>
          <objective-card v-model="dep.userObjectives" :mode="0" :sequencenum="sequencenum" @changed="dep.changed=true"
            @removeUserPerf="removeUserPerf">
          </objective-card>
        </v-tab-item>
      </v-tabs-items>
      
      <v-dialog
        v-model="msgdialog"
        width="500"
      >
        <v-card color="error">
          <v-card-title>
            提示
          </v-card-title>
          <v-card-text class="white--text" style="white-space: pre-line; max-height: 60vh; overflow-y: auto;">
            <v-icon>mdi-alert-box-outline</v-icon>
            {{msg}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="dialogtype != 0"
            color="error"
            @click="dialogcancel()"
            class="text-caption"
            >
            取消
            </v-btn>
            <v-btn
            color="error"
            @click="dialogconfirm()"
            class="text-caption"
            >
            确定
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
</template>
<script>
    import ObjectiveCard from './ObjectiveCard.vue'
    import DepartmentSelector from './DepartmentSelector.vue'
    import _ from 'lodash'
    import { mapState, mapGetters } from 'vuex'
    import FileHelper from '@/utils/filehelper.js'
    import { sortDepartmentsByName } from '@/utils/departmentsort.js'

    export default {
        name: 'PerfDesign',
        components: {
          ObjectiveCard,
          DepartmentSelector
        },
        data: () => ({
          tab:0,
          departmentUserObjectives:[],
          sequencenum:0,
          importedfile: null,
          importdialog:false,
          userObjectiveService:null,
          msgdialog:false,
          msg:'',
          dialoglistener:{},
          dialogtype: 0
        }),
        watch: {
          departmentid: {
            deep: true,
            handler: function(val, oldval) {
              console.log(`PerfDesign departmentid changed:${val}, :${oldval}`)
              this.importedfile = null
              this.loadData(val)
            }
          }
        },
        computed: {
          ...mapState(['cur_user', 'departmentsettings']),
          ...mapGetters(['myCurManageDepartment','myManageDepartments'])
        },
        created() {
          // console.log(`attrs:${JSON.stringify(this.attrs)},${this.departmentid},${this.departmentname}`)
          this.userObjectiveService = this.$store.getters.service('user-objective')
          this.firstLoad()
        },
        methods: {
          async firstLoad() {
            const me = this

            const myDepartments = sortDepartmentsByName(
              this.cur_user.isAdmin? me.departmentsettings:me.myManageDepartments)

            myDepartments.forEach(ds => {
                me.departmentUserObjectives.push({departmentid:ds.departmentid, departmentname:ds.departmentname, 
                  changed:false, userObjectives:[]})
            })

            const { data } = await this.userObjectiveService.find(this.cur_user.isAdmin?{}:
              {query:{departmentid:{$in:myDepartments.map(dp => dp.departmentid)}}})

            data.forEach(userObj => {
              const duo = me.departmentUserObjectives.find(duo => duo.departmentid === userObj.departmentid)
              if (!duo) {
                console.log(`unknown department id, orphan user objective after department deleted?. id:${userObj._id}-departmentid:${userObj.departmentid}`)
              } else {
                duo.userObjectives.push(userObj)
              }
            })
            me.departmentUserObjectives.forEach(duo => 
              duo.userObjectives.sort((a, b)=> a.userid < b.userid ? -1:(a.userid === b.userid? 0:1)))
          },

          async loadOneDepartment(oneDepartmentUserObjectives) {
            const { data } = await this.userObjectiveService.find({query:{departmentid:oneDepartmentUserObjectives.departmentid}})

            oneDepartmentUserObjectives.userObjectives = data
            oneDepartmentUserObjectives.userObjectives.sort((a, b)=> a.userid < b.userid ? -1:(a.userid === b.userid? 0:1))
          },

          fileimport(file) {
            
            if (!file) return

            const departmentid = this.departmentUserObjectives[this.tab].departmentid
            const departmentname = this.departmentUserObjectives[this.tab].departmentname

            const dep = this.departmentUserObjectives[this.tab]

            setTimeout(()=>{
              console.log(`fileimport fired`)

              const reader = new FileReader()
              reader.onload = (e) => {
                const data = new Uint8Array(e.target.result)

                try {
                  let importeddata = FileHelper.readfile({data, departmentid, 
                    departmentname, departmentsettings:this.departmentsettings})

                  dep.userObjectives = importeddata
                  dep.changed = true

                  this.importedfile = null
                  this.showMsg({msg:`内容已经导入，请核对绩效目标后保存。保存后原有内容会被覆盖。`, dialogtype:0})
                } catch (error) {
                  const msg = error && error.isImportError
                    ? error.message
                    : '导入失败：处理文件时发生错误，请确认文件是有效的 Excel 文件（.xlsx）。'

                  this.showMsg({msg, dialogtype:0})
                }

                // this.importdialog = true
                this.sequencenum++
              }
              reader.readAsArrayBuffer(file)
            })
          },

        validateData(val) {

            console.log(`validateData userobjs`)
            const validateResult = {pass:true,msg:''}

            validateResult.pass = !val.some(userinfo=>{
                if (!userinfo.userid) {
                    validateResult.msg = `请重新选择用户“${userinfo.username}”`
                    return true
                }

                return userinfo.objectives.some(obj=>{
                    return obj.items.some(item=>{
                        return item.ratedepartments.some(d=>{
                            if (!d.id) {
                                validateResult.msg = `请重新选择用户“${userinfo.username}”下考核项目“${obj.name}”分项“${item.name}”的考核部门`
                                return true
                            } else {
                                return false
                            }
                        })
                    })  
                })
            })

            console.log(`validate event:${JSON.stringify(validateResult)}`)
            return validateResult
        },

          showMsg({msg, dialogtype, onConfirm, onCancel}) {
              this.msg = msg,
              this.dialogtype = dialogtype
              this.msgdialog = true
              this.dialoglistener.onCancel = onCancel
              this.dialoglistener.onConfirm = onConfirm
          },
          dialogcancel() {
            this.msgdialog = false
            if (this.dialoglistener.onCancel) this.dialoglistener.onCancel()
          },
          dialogconfirm() {
            this.msgdialog = false
            if (this.dialoglistener.onConfirm) this.dialoglistener.onConfirm()
          },

          genTotalRateDepartments(userobjs) {

            FileHelper.walkthroughItems(userobjs, {userobjectivescb:({userobjectives})=>userobjectives.ratedepartments = [], 

              itemcb:({item, userobjectives})=> {
                userobjectives.ratedepartments = _.unionBy(userobjectives.ratedepartments, item.ratedepartments, 'id')
                // console.log(`gen ${userobjectives.username}, 
                //  uobjs rate:${JSON.stringify(userobjectives.ratedepartments)}, 
                  // item.rate:${JSON.stringify(item.ratedepartments)}`)
              },
              creteriacb: ({creteria}) => {
                if (creteria.isPercent) creteria.fullpoints = creteria.points
              }
            })
          },

          save(oneDepartmentUserObjectives) {

            console.log(`save`)
            const validateResult = this.validateData(oneDepartmentUserObjectives.userObjectives)
            if (!validateResult.pass) {
              this.showMsg({msg:validateResult.msg, dialogtype:0})
              return
            }

            this.genTotalRateDepartments(oneDepartmentUserObjectives.userObjectives)

            Promise.all(oneDepartmentUserObjectives.userObjectives.map(userobj=>{

              const params = {
                query:{userid:userobj.userid, 
                  departmentid:userobj.departmentid}}
              
              return this.userObjectiveService.patch(null, userobj, params)
            })).then((results)=>{
              console.log(`save results:${JSON.stringify(results)}`)
              this.showMsg({msg:'保存成功。', dialogtype:0})
              this.loadOneDepartment(oneDepartmentUserObjectives)
            }).catch (e =>{
              this.showMsg({msg:`保存失败: ${e.message}`, dialogtype:0})
            })
          },
          removeOneUserObjectiveLocally(userobj) {
            const duo = this.departmentUserObjectives.find(duo => duo.departmentid == userobj.departmentid)
            const index = duo.userObjectives.findIndex(uo => uo._id == userobj._id)
            if (index != -1 ) duo.userObjectives.splice(index, 1)
          },
          removeUserPerf(userobj) {
            console.log(`removeUserPerf:${userobj.username}`)
            const me = this
            this.showMsg({msg:`确认删除 "${userobj.username}" 的绩效考核目标吗？`, dialogtype:1, onConfirm: async () =>{
              console.log(`remove confirmed, id:${userobj._id}`)
              try {
                await me.userObjectiveService.remove(userobj._id)
                me.removeOneUserObjectiveLocally(userobj)

                me.showMsg({msg:`数据删除成功。`, dialogtype:0})
              } catch (error) {
                me.showMsg({msg:`数据删除出错:${error.message}`, dialogtype:0})
              }
            }})
          }
        }
    }
</script>